__webpack_require__.p = "https://fe.registry.geostudio.app.amazon.dev/";